module.exports = "/dist/img/checkered.jpg";